import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Card from '../card/card';
import FCLink from '../fc_link/fc_link';
import { trackGAEvent } from '../../../client/utils/third_party_trackers/ga';
import withTracking from '../../../utils/tracking/components/withTracking';
import { defaultClick } from '../../../utils/tracking/events/pageEvents';
import EventModel from '../../../utils/tracking/models';

// eslint-disable-next-line react/prefer-stateless-function
class Recirc extends Component {
  render() {
    const { config, feed } = this.props;
    const properties = [
      {
        key: 'ideas', // to be updated to impact, work life, creativity
        title: 'Impact',
        data: get(feed, 'ideas', []), // to be updated to impact, work life, creativity
        link: 'https://www.fastcompany.com/impact'
      },
      {
        key: 'entertainment', // to be updated to impact, work life, creativity
        title: 'Creativity',
        data: get(feed, 'entertainment', []), // to be updated to impact, work life, creativity
        link: 'https://www.fastcompany.com/creativity'
      },
      {
        key: 'design',
        title: 'Co.Design',
        data: get(feed, 'design', []),
        link: 'https://www.fastcompany.com/co-design'
      },
      {
        key: 'fastcompany',
        title: 'Work Life',
        data: get(feed, 'leadership', []), // to be updated to impact, work life, creativity
        link: 'https://fastcompany.com/work-life'
      }
    ];

    return (
      <div className="recirc">
        {properties.map(property => (
          <div key={property.key} className="recirc__column">
            <h3 className={`recirc__title recirc__title--${property.key}`}>
              <FCLink config={config} to={property.link}>
                {property.title}
              </FCLink>
            </h3>
            {property.data.map((story, idx) => (
              <Card
                type="recirc"
                config={config}
                metadata={story}
                key={story.id}
                cardEvent={() => {
                  // [DataLayer] trigger nav item click event
                  const clickEvent = new EventModel(
                    `Recirculation Item Click | ${get(story, 'id')}`,
                    `recirc | ${property.title} > ${get(story, 'id')}`,
                    'bottomRecirc',
                    `bottomRecirc | ${property.title} > ${get(story, 'id')}`,
                    idx + 1
                  );
                  this.props.trackClick(clickEvent.getTrackingObject());

                  trackGAEvent({
                    eventCategory: 'Engagement',
                    eventAction: `RecirculationModule:Pos-${idx + 1}`,
                    eventLabel: `${property.title}:${get(story, 'link')}`
                  });
                }}
              />
            ))}
          </div>
        ))}
      </div>
    );
  }
}

Recirc.defaultProps = {
  trackClick: () => false
};

Recirc.propTypes = {
  config: PropTypes.shape({}).isRequired,
  feed: PropTypes.shape({}).isRequired,
  trackClick: PropTypes.func
};

const mapTrackingToProps = trackEvent => ({
  trackClick: pageObject => trackEvent(defaultClick(pageObject))
});

const trackedRecirc = withTracking(mapTrackingToProps)(Recirc);

export default trackedRecirc;
